import { render, staticRenderFns } from "./RawClampColumn.vue?vue&type=template&id=7d6c7f70&scoped=true"
import script from "./RawClampColumn.vue?vue&type=script&lang=js"
export * from "./RawClampColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c7f70",
  null
  
)

export default component.exports